export default {
  identification: 'Identificación',
  country: 'País',
  department: 'Departamento',
  description: 'Descripción',
  charge: 'Cargo',
  screen: 'Pantalla'
}
